<template src="./index.html"></template>
<script>
import bus from '../../util/bus';

export default {
	data() {
		return {
			collapse: false,
			items: [],
			routes: {},
            name: ""
		};
	},
	computed: {
		onRoutes(e) {
			return this.$route.path.replace('/', '');
		}
	},
	methods: {
		meautree(userobj) {
			var meau = [
				{
					icon: 'meauicon9',
					label: '首页',
					index: '/home'
				},
                {
                    icon: 'el-icon-s-home',
                    label: '首页',
                    index: '/HomePageNew'
                },
                {
                    icon: 'meauicon9',
                    label: '待办事项',
                    index: 'todo'
                },
				{
					icon: 'meauicon1',
					label: '数据采集',
					index: 'DataAcquisition',
					children: [
						{
							index: 'subject',
							label: '科目余额表'
						},
						{
							index: 'nsreport',
							label: '进项增值税'
						},
            {
              index: 'iinvSubLeger',
              label: '进项明细账'
            },
						{
							index: 'tralvel',
							label: '客运抵扣凭证'
						},
						{
							index: 'dkdj',
							label: '代扣代缴凭证'
						},
						{
							index: 'customs',
							label: '海关缴款书'
						},
						{
							index: 'AgricultureProducts',
							label: '农产品收购'
						},
						{
							index: 'oinv',
							label: '销项增值税'
						},
						{
							index: 'subLeger',
							label: '明细账'
						},
						{
							index: 'openInvoice',
							label: '开票数据'
						},
						{
							index: 'redLetter',
							label: '红字信息表'
						},
						{
							index: 'contract',
							label: '合同台账'
						},
						{
							index: 'transport',
							label: '旅客运输'
						},
						{
							index: 'inputCertification',
							label: '进项认证'
						}
					]
				},
				{
					icon: 'meauicon2',
					label: '数据治理',
					index: 'DataGovernance',
					children: [
						{
							index: 'jxzc',
							label: '进项转出'
						},
						{
							index: 'qedk',
							label: '全额抵扣'
						},
						{
							index: 'wpsr',
							label: '无票收入'
						},
						{
							index: 'yhs',
							label: '印花税'
						},
						{
							index: 'cztdsys',
							label: '城镇土地使用税'
						},
						{
							index: 'hjbhs',
							label: '环境保护税'
						}
					]
				},
				{
					icon: 'meauicon3',
					label: '申报底稿',
					index: 'Applicationdraft',
					children: [
						{
							index: 'Draftgeneration',
							label: '底稿生成'
						},
						{
							index: 'xggj',
							label: '操作记录'
						},
						{
							index: 'bbmb',
							label: '报表模板'
						},
						{
							index: 'workManuscript',
							label: '工作底稿'
						},
						{
							index: 'qcsj',
							label: '期初数据'
						}
					]
				},
				{
					icon: 'meauicon4',
					label: '纳税申报',
					index: 'Taxdeclaration',
					children: [
						{
							index: 'sbjk',
							label: '申报缴款'
						},
						{
							index: 'sbdbsz',
							label: '申报对比配置'
						},
						{
							index: 'sbdbjg',
							label: '申报对比结果'
						}
					]
				},
				{
					icon: 'meauicon5',
					label: '税务知识库',
					index: 'Taxknowledgebase',
					children: [
						{
							index: 'zcfg',
							label: '政策法规'
						},
						{
							index: 'cszd',
							label: '财税制度'
						},
						{
							index: 'csal',
							label: '财税案例'
						}
					]
				},
                {
                    icon: 'meauicon10',
                    label: '销项税会差异',
                    index: 'TaxDiscrepancy',
                    children: [
                        {
                            index: 'sjclzx',
                            label: '数据处理中心'
                        },
                        {
                            index: 'xxtjbyl',
                            label: '销项调节表一览'
                        },
                        {
                            index: 'ywlxgz',
                            label: '业务类型规则'
                        }
                    ]
                },
        {
          icon: 'meauicon10',
          label: '进项税会差异',
          index: 'IinvTaxDiscrepancy',
          children: [
            {
              index: 'iinvsjclzx',
              label: '数据处理中心'
            },
            {
              index: 'iinvdkdj',
              label: '代扣代缴'
            },
            {
              index: 'iinvhgjks',
              label: '海关缴款书'
            },
              {
                  index:'iinvjxtjbyl',
                  label:"进项调节一览"
              }
          ]
        },
        {
          icon: 'meauicon11',
          label: '即征即退',
          index: 'requisition',
          children: [
            {
              index: 'requisitionIinv',
              label: '进项发票表'
            },
            {
              index: 'requisitionOinv',
              label: '销项发票表'
            },
            {
              index: 'requisitionDraft',
              label: '即征即退底稿'
            }
          ]
        },
				{
					icon: 'meauicon6',
					label: '风险管理',
					index: 'Riskmanagement',
					children: [
						{
							index: 'hmdgl',
							label: '灰名单管理'
						},
						{
							index: 'fxjk',
							label: '风险监控'
						},
						{
							index: 'tzsz',
							label: '通知设置'
						},
						{
							index: 'tzmb',
							label: '通知模板'
						},
						{
							index: 'jkhz',
							label: '监控汇总'
						},
						{
							index: 'hztj',
							label: '指标监控'
						}
					]
				},
				{
					icon: 'meauicon7',
					label: '审核中心',
					index: 'AuditCenter',
					children: [
						{
							index: 'dgsh',
							label: '底稿审核'
						}
					]
				},
				{
					icon: 'meauicon8',
					label: '配置中心',
					index: 'ConfigurationCenter'
				},
				{
					icon: 'meauicon9',
					label: '配置中心',
					index: 'OperationLog'
				}
			];
			return meau;
		},
		forchangeMeau() {
			this.collapse = !this.collapse;
			bus.$emit('collapse-content', this.collapse);
		}
	},
	watch: {
		$route(to, from) {
			this.items.forEach(item => {
				if (item.resCode == to.path.split('/')[1]) {
					this.name = item.resName;
				} else if (item.children.length != 0) {
					item.children.forEach(item1 => {
						if (item1.resCode == to.path.split('/')[1]) {
							this.name = item.resName;
						}
					});
				}
			})
		}
	},
	created() {
		if (this.$notemptyandnull(localStorage.getItem('zcfgmeaus'))) {
			this.items = JSON.parse(localStorage.getItem('zcfgmeaus'));
		} else if (this.$notemptyandnull(localStorage.getItem('hmdglmeaus'))) {
			this.items = JSON.parse(localStorage.getItem('hmdglmeaus'));
		} else if (this.$notemptyandnull(localStorage.getItem('hlsmeaus'))) {
			this.items = JSON.parse(localStorage.getItem('hlsmeaus'));
		} else {
			this.items = JSON.parse(localStorage.getItem('meaus'));
		}
		this.items.forEach(item => {
			if (item.resCode == this.$route.path.split('/')[1]) {
				this.name = item.resName;
			} else if (item.children.length != 0) {
				item.children.forEach(item1 => {
					if (item1.resCode == this.$route.path.split('/')[1]) {
						this.name = item.resName;
					}
				})
			}
		})
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
@import url('../../../assets/css/Sidebar.css');
</style>
